import {Modal} from '@/components/atoms'
import {SaveCancelFooter} from '@/components/molecules'
import {PageContent} from '@/components/organisms'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMemo, useState} from 'react'

import {useNavigate, useParams} from 'react-router-dom'
import {ProductMediaGallery} from './ProductMediaGallery/ProductMediaGallery'
import {useMediaGallery} from './useMediaGallery'

const MediaGalleryEdit = ({mediaSlots, isUploading, updateMediaSlot, clearMediaSlot, handleSave}) => {
  const [isCancel, setIsCancel] = useState(false)
  const navigate = useNavigate()
  const {id} = useParams()

  const {
    mediaSlots: galleryMediaSlots,
    isDeletingFromServer,
    handleUpload,
    handleUploadError,
    handleDeleteImage,
    handleDeleteFromServer,
    handleReorder,
    mediaSlotUiState,
  } = useMediaGallery({
    productId: id,
    mediaSlots,
    updateMediaSlot,
    clearMediaSlot,
  })

  const hasImageInFirstSlot = useMemo(() => {
    const firstSlot = galleryMediaSlots.find(slot => slot.displayOrder === 1)
    if (!firstSlot) return false

    // Reorder validation can set slot errors via mediaSlotUiState even when slot media doesn't change.
    const firstSlotUiState = mediaSlotUiState?.[1]
    if (firstSlotUiState?.error?.feedbackType === 'error') return false
    if (firstSlot?.error?.feedbackType === 'error') return false

    return Boolean(firstSlot?.file || firstSlot?.imageUri)
  }, [galleryMediaSlots, mediaSlotUiState])

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }

  const onClickPrimaryButton = () => {
    navigate(`${ROUTES.PRODUCT_REVIEW.replace(':id', id)}`, {state: {selectedTabNumb: 1}})
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  return (
    <>
      <PageContent className="media-gallery-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <ProductMediaGallery
          mediaSlots={galleryMediaSlots}
          isUploading={isUploading || isDeletingFromServer}
          handleUpload={handleUpload}
          handleUploadError={handleUploadError}
          handleDeleteImage={handleDeleteImage}
          handleDeleteFromServer={handleDeleteFromServer}
          handleReorder={handleReorder}
          mediaText={'Product Media'}
        />
      </PageContent>
      {isCancel ? (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={isCancel}
          onCloseModal={handleCancel}
          title="Are you sure you want to cancel?"
          text={'The changes will not be saved.'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={onClickPrimaryButton}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={onClickSecondaryButton}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      ) : null}
      <SaveCancelFooter
        handleCancel={handleCancel}
        nextAction={() => handleSave()}
        isReview={true}
        hideSaveDraft={true}
        FormError={!hasImageInFirstSlot}
      />
    </>
  )
}

export default MediaGalleryEdit
